var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:".el-container",attrs:{"direction":"vertical"}},[_c('Header'),_c('el-container',[_c('Aside'),_c('el-main',{staticClass:".el-main"},[_c('el-backtop',{attrs:{"target":".el-main"}}),_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }